import { useEffect, useState } from "react";
import { Mail, MailOpen, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const fmt = (iso) => new Date(iso).toLocaleString("en-CA", { dateStyle: "medium", timeStyle: "short" });

export const Inbox = () => {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/messages").then((r) => setItems(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => {
    load();
  }, []);

  const toggle = async (m) => {
    await api.patch(`/admin/messages/${m.id}`, { read: !m.read });
    load();
  };
  const remove = async (m) => {
    if (!window.confirm(`Delete the message from ${m.name}?`)) return;
    await api.delete(`/admin/messages/${m.id}`);
    toast.success("Message deleted");
    load();
  };

  if (!items) return <p className="text-[#6B7280]">Loading…</p>;
  if (!items.length) return <p className="card-soft p-8 text-[#6B7280]" data-testid="inbox-empty">No messages yet.</p>;
  return (
    <ul className="space-y-4" data-testid="inbox-list">
      {items.map((m) => (
        <li key={m.id} className={`card-soft p-6 ${m.read ? "opacity-75" : "border-[#6F5B9E]/50"}`} data-testid={`inbox-item-${m.id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-display text-2xl text-[#22304A]">{m.name} {!m.read && <span className="ml-2 rounded-full bg-[#6F5B9E] px-2 py-0.5 align-middle font-sans text-xs text-white">New</span>}</p>
              <p className="mt-1 text-sm text-[#6B7280]">
                <a href={`mailto:${m.email}`} className="text-link">{m.email}</a>{m.phone ? ` · ${m.phone}` : ""} · {fmt(m.created_at)}
                {!m.emailed && " · email notification not delivered"}
              </p>
            </div>
            <div className="flex gap-2">
              <button onClick={() => toggle(m)} className="rounded-full p-2 text-[#22304A] hover:bg-[#B9A9D8]/20" aria-label={m.read ? "Mark as unread" : "Mark as read"} data-testid={`inbox-toggle-read-${m.id}`}>
                {m.read ? <Mail className="h-4 w-4" /> : <MailOpen className="h-4 w-4" />}
              </button>
              <button onClick={() => remove(m)} className="rounded-full p-2 text-[#6B7280] hover:bg-[#991B1B]/10 hover:text-[#991B1B]" aria-label="Delete message" data-testid={`inbox-delete-${m.id}`}>
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
          <p className="mt-4 whitespace-pre-wrap leading-relaxed text-[#22304A]/85">{m.message}</p>
        </li>
      ))}
    </ul>
  );
};
